import React from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { WeeklyTipsChart } from './WeeklyTipsChart';
import { DashboardSummary } from './DashboardSummary';
import { LaunchChecklist } from './LaunchChecklist';
import { StaffPerformanceDashboard } from './StaffPerformanceDashboard';
import { DashboardFiltersProvider } from '../contexts/DashboardFiltersContext';
import { useStoreLocation } from '../contexts/LocationContext';
import { MapPin, Layers } from 'lucide-react';

export const Dashboard: React.FC = () => {
  const { tenantId } = useFirebase();
  const { activeLocation, isConsolidated, hierarchyRole } = useStoreLocation();
  const storeDisplayName = activeLocation?.name || 'Store Location';

  return (
    <DashboardFiltersProvider>
      <div className="space-y-6 md:space-y-12 pb-20">
        {tenantId && <LaunchChecklist tenantId={tenantId} />}

        <div className="space-y-6">
          <header className="border-b border-gray-200 pb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <div className="flex flex-wrap items-center gap-2">
                <h1 className="text-xl font-black text-gray-900 uppercase tracking-widest">Dashboard</h1>
                {isConsolidated ? (
                  <span className="inline-flex items-center gap-1 text-xs px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-800 font-bold border border-blue-200">
                    <Layers size={12} />
                    All Stores (Consolidated)
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-1 text-xs px-2.5 py-0.5 rounded-full bg-slate-100 text-slate-800 font-bold border border-slate-200">
                    <MapPin size={12} className="text-blue-600" />
                    {storeDisplayName}
                  </span>
                )}
              </div>
              <p className="text-gray-500 font-medium text-xs mt-1">
                {isConsolidated 
                  ? 'Displaying company-wide financial totals and aggregated shift operations' 
                  : `Store-level view for ${storeDisplayName}`}
              </p>
            </div>
          </header>

          {tenantId && <DashboardSummary />}
          
          {tenantId && <WeeklyTipsChart tenantId={tenantId} />}

          {tenantId && <StaffPerformanceDashboard tenantId={tenantId} />}

        </div>
      </div>
    </DashboardFiltersProvider>
  );
};
